import React from 'react';
import { Box, Flex, Text, Loader } from '@marvelapp/ui';
import { FailedIcon } from './icons';
import { IMAGE_UPLOAD_ERROR, IMAGE_UPLOAD_PENDING, } from '../constants/contentStatus';
export default function ImageError(_a) {
    var status = _a.status, message = _a.message;
    return (React.createElement(Flex, { alignItems: "center", flexDirection: "column", height: "100%", justifyContent: "center", padding: 3 },
        React.createElement(Icon, { status: status }),
        React.createElement(Text, { textAlign: "center" }, message)));
}
function Icon(_a) {
    var status = _a.status;
    switch (status) {
        case IMAGE_UPLOAD_PENDING:
            return (React.createElement(Box, { marginBottom: 3 },
                React.createElement(Loader, { size: 32 })));
        case IMAGE_UPLOAD_ERROR:
            return (React.createElement(Box, { marginBottom: 3 },
                React.createElement(FailedIcon, { color: "red" })));
        default:
            return null;
    }
}
export function ImageUploadFailedError() {
    return (React.createElement(ImageError, { hasError: true, isThumb: true, message: "This image has failed to upload and needs to be reuploaded!" }));
}
export function ImageUploadPendingError() {
    return (React.createElement(ImageError, { isLoading: true, isThumb: true, message: "This image is still uploading to the server! Check back in a few seconds." }));
}
export function ImageDownloadError() {
    return (React.createElement(ImageError, { hasError: true, isThumb: true, message: "This image has failed to download, please try to reupload." }));
}
